import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

const posterImages: Record<string, string> = {
  'movie-interstellar': 'https://readdy.ai/api/search-image?query=Interstellar%20Chinese%20movie%20poster%20design%20dramatic%20lighting%20cinematic%20film%20poster%20dark%20moody%20background%20warm%20golden%20accents%20professional%20movie%20poster%20artwork&width=600&height=900&seq=poster-interstellar&orientation=portrait',
  'movie-wandering-earth': 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%202%20Chinese%20sci%20fi%20movie%20poster%20design%20dramatic%20lighting%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20movie%20poster%20artwork&width=600&height=900&seq=poster-wandering-earth&orientation=portrait',
  'movie-hi-mom': 'https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20drama%20movie%20poster%20design%20warm%20nostalgic%20lighting%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20movie%20poster%20artwork&width=600&height=900&seq=poster-hi-mom&orientation=portrait',
  'movie-changjin': 'https://readdy.ai/api/search-image?query=The%20Battle%20at%20Lake%20Changjin%20Chinese%20war%20drama%20movie%20poster%20design%20dramatic%20lighting%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20movie%20poster%20artwork&width=600&height=900&seq=poster-changjin&orientation=portrait',
  'tv-zhenhuan': 'https://readdy.ai/api/search-image?query=Empresses%20in%20the%20Palace%20Chinese%20period%20drama%20poster%20design%20elegant%20lighting%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20drama%20poster%20artwork&width=600&height=900&seq=poster-zhenhuan&orientation=portrait',
};

export default function FeaturedMovies() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-white font-heading">精选推荐</h2>
          <p className="text-sm text-foreground-400 mt-1">编辑精选，不容错过的优质影视</p>
        </div>
        <Link
          to="/category/hot"
          className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
        {featuredMovies.map((movie) => {
          const posterSrc = posterImages[movie.imageSeq] || posterImages['movie-interstellar'];
          return (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group block"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-background-800">
                <img
                  src={posterSrc}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${movie.title} - 高清电影免费在线观看`}
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-primary-400 font-semibold flex items-center gap-1">
                  <i className="ri-star-fill text-[10px]"></i> {movie.rating}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs font-medium flex items-center gap-1">
                    <i className="ri-play-circle-fill text-primary-400"></i> 点击观看
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-white group-hover:text-primary-400 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">
                {movie.year} · {movie.categoryName}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}